var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('landing'),(!!_vm.isAuthenticated)?_c('app-footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }